import { fg } from '@atlassian/jira-feature-gating';

const LINK_IS_BLOCKED_BY = 'is blocked by' as const;
const NEW_LINK_BLOCKS = 'blocks' as const;
const LINK_IS_DUPLICATED_BY = 'is duplicated by' as const;
const LINK_BLOCKS = 'BLOCKS' as const;
const LINK_IS_CLONED_BY = 'is cloned by' as const;
const LINK_CLONES = 'clones' as const;
const LINK_IS_CAUSED_BY = 'is caused by' as const;
const LINK_CAUSES = 'causes' as const;
const LINK_RELATES_TO = 'relates to' as const;
const LINK_DUPLICATES = 'duplicates' as const;
const LINK_IMPLEMENTS = 'implements' as const;
const LINK_IMPLEMENTED_BY = 'is implemented by' as const;

// use LINK_CUSTOM for all custom type name
const LINK_CUSTOM = 'custom' as const;

type LinkIssueType =
	| typeof LINK_IS_BLOCKED_BY
	| typeof LINK_IS_DUPLICATED_BY
	| typeof LINK_BLOCKS
	| typeof LINK_IS_CLONED_BY
	| typeof LINK_CLONES
	| typeof LINK_IS_CAUSED_BY
	| typeof LINK_CAUSES
	| typeof LINK_RELATES_TO
	| typeof LINK_DUPLICATES;

type NewLinkIssueType =
	| typeof LINK_IS_BLOCKED_BY
	| typeof NEW_LINK_BLOCKS
	| typeof LINK_IS_DUPLICATED_BY
	| typeof LINK_DUPLICATES
	| typeof LINK_IS_CLONED_BY
	| typeof LINK_CLONES
	| typeof LINK_IS_CAUSED_BY
	| typeof LINK_CAUSES
	| typeof LINK_RELATES_TO
	| typeof LINK_IMPLEMENTED_BY
	| typeof LINK_IMPLEMENTS;

const LINK_ISSUE_TYPE: LinkIssueType[] = [
	LINK_IS_BLOCKED_BY,
	LINK_IS_DUPLICATED_BY,
	LINK_BLOCKS,
	LINK_IS_CLONED_BY,
	LINK_CLONES,
	LINK_IS_CAUSED_BY,
	LINK_CAUSES,
	LINK_RELATES_TO,
	LINK_DUPLICATES,
];

const NEW_LINK_ISSUE_TYPE: NewLinkIssueType[] = [
	LINK_IS_BLOCKED_BY,
	NEW_LINK_BLOCKS,
	LINK_IS_DUPLICATED_BY,
	LINK_DUPLICATES,
	LINK_IS_CLONED_BY,
	LINK_CLONES,
	LINK_IS_CAUSED_BY,
	LINK_CAUSES,
	LINK_RELATES_TO,
	LINK_IMPLEMENTED_BY,
	LINK_IMPLEMENTS,
];

export const safeLinkTypeName = (value: string): string => {
	if (fg('jira_issue_links_analytics')) {
		// Using type coercion to handle type mismatch between string and NewLinkIssueType
		return NEW_LINK_ISSUE_TYPE.some((linkType) => linkType === value?.toLowerCase())
			? value
			: LINK_CUSTOM;
	}

	// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'LinkIssueType'.
	return LINK_ISSUE_TYPE.includes(value) ? value : LINK_CUSTOM;
};
